import React, {Component} from 'react';

class Confirm extends Component {
    render() {
        return (
            <div className={'aboutContainer'}>
                <h1 className={"About-Header"}>Thank you for Registering!</h1>
                <div className={"About-Wrapper"}>
                    <p  className={"About-Content"}>Your registration has been confirmed. Please proceed to the payment tab or alternatively, <a href={"/pay"}>click here</a> to complete payment.</p>



                    <p  className={"About-Content"}>If you have not reserved a room please <a href={"https://reservations.snowbird.com/default.aspx?p=&group=PQE123&arrival=01/08/2023&depart=01/13/2023&bookingstep=1"}>click here</a> to reserve a room.</p>
                </div>



            </div>
        );
    }
}

export default Confirm;